import { useEffect } from "react";
import { getSocket } from "@/sockets/socket";

/** Subscribe to a single Socket.IO event for the lifetime of the calling component. */
export function useSocketEvent<T = unknown>(
  event: string,
  handler: (payload: T) => void,
  deps: React.DependencyList = [],
) {
  useEffect(() => {
    const socket = getSocket();
    const listener = (payload: T) => handler(payload);
    socket.on(event, listener);
    return () => {
      socket.off(event, listener);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event, ...deps]);
}
